import { useState } from "owa-react";
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Avoid deprecated APIs, use portals instead of rendering to a new root
 *	> 'render' import from 'owa-react-dom' is restricted. Use react portals instead of rendering into a new root */
import { render } from "owa-react-dom";
import { ThemeProvider } from "@fluentui/react/lib/Theme";
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Panel from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Drawer from '@fluentui/react-components' instead. */
import { Panel } from "@fluentui/react/lib/Panel";
import React from "react";
import { useWindowEvent } from "owa-react-hooks/lib/useWindowEvent";
import { lazyHandleSupportPaneEvents, lazyGetIframeUrl as getIframeUrl, feedbackScenarioName, } from "diagnostics-and-support";
import { getApp } from "owa-config";
import { content, scrollableContent, container } from "./OcvFeedbackPanel.scss";

interface OcvFeedbackPanelProps {
    iframeUrl: string;
    onDismissed: () => void;
}

const panelStyles = {
    content,
    scrollableContent,
};

function OcvFeedbackPanel(props: OcvFeedbackPanelProps) {
    const [isOpen, setIsOpen] = useState(true);
    const dismissPanel = React.useCallback(() => setIsOpen(false), []);
    useWindowEvent("message", (messageEvent: any) => {
        lazyHandleSupportPaneEvents.importAndExecute(messageEvent, dismissPanel);
    }, "accelerator_OcvFeedbackPanel");
    return (<Panel isOpen={isOpen} onDismiss={dismissPanel} onDismissed={props.onDismissed} styles={panelStyles} isBlocking={false}>
            <iframe src={props.iframeUrl} width={"100%"} height={"100%"} frameBorder="none" scrolling="auto" className={container} allow="display-capture"/>
        </Panel>);
}
export default function renderOcvFeedbackPanel(): void {
    const featureFlagsDiv = document.createElement("div");
    window.document.body.appendChild(featureFlagsDiv);
    let unmount: (() => void) | undefined;
    const cleanup = () => {
        unmount?.();
        featureFlagsDiv.remove();
    };
    getIframeUrl.importAndExecute(feedbackScenarioName, getApp()).then(url => {
        unmount = render(<ThemeProvider role={"complementary"} tabIndex={-1}>
                <OcvFeedbackPanel iframeUrl={url} onDismissed={cleanup}/>
            </ThemeProvider>, featureFlagsDiv);
    });
}
